import { gql } from '@apollo/client';

const GET_PRODUCT = gql`
  query getProduct($id: String!) {
    getPublishedProduct(id: $id) {
      id
      editionIssueNumber
      uk_publication_date
      us_publication_date
      ukIsDisabled
      usIsDisabled
      einspectionCopyAvailable
      printInspectionCopyAvailable
      blazeId
    }
  }
`;

const GET_PRODUCT_WITH_VARIANTS = gql`
  query getProductWithVariants($id: String!) {
    getPublishedProduct(id: $id) {
      id
      name
      ean
      slug
      editionIssueNumber
      uk_publication_date
      us_publication_date
      ukIsDisabled
      usIsDisabled
      formattedVariants {
        price
        variantId
        attributes
      }
      subjects {
        id
        name
        parentId
      }
      category {
        id
        name
      }
      personas {
        id
        name
      }
    }
  }
`;

const GET_PRODUCT_VARIANTS_QUERY = gql`
  query ecommerceGetProductVariants($id: String, $currency: String, $entityIdentifier: String) {
    productVariants: ecommerceGetProductVariants(
      id: $id
      currency: $currency
      entityIdentifier: $entityIdentifier
    ) {
      variantId
      name
      price
    }
  }
`;

export { GET_PRODUCT_WITH_VARIANTS, GET_PRODUCT, GET_PRODUCT_VARIANTS_QUERY };
